import React from "react";

import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import ResetConfirmationModal from "UserAdmin/components/resetpasswordmodal";

interface Props {
  optionsPanel: server.dto.OptionsPanelDataV2
  listUrl: string
  userId: number;
}

const UserDetailOptionsPanel = (props: Props) => {
  const [displayResetPassword, setDisplayResetPassword] = React.useState(false);

  return <>
    <GeneralOptionsPanel
      data={props.optionsPanel}
      links={[
        { text: "List view", visible: true, href: props.listUrl },
        { text: "Reset password", visible: true, onClick: () => { setDisplayResetPassword(true); } },

      ]}
    />

    <ResetConfirmationModal
      isOpen={displayResetPassword}
      userId={props.userId}
      onClose={() => { setDisplayResetPassword(false); }}
    />
  </>

};

export default UserDetailOptionsPanel;